var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.927,
    height: 21.927,
    viewBox: "0 0 21.927 21.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-map",
    "data-name": "Icon material-map",
    d: "M25.818,4.5l-.195.037L19.118,7.058,11.809,4.5,4.939,6.815A.614.614,0,0,0,4.5,7.4V25.818a.6.6,0,0,0,.609.609l.195-.037,6.505-2.522,7.309,2.558,6.871-2.315a.614.614,0,0,0,.439-.585V5.109A.6.6,0,0,0,25.818,4.5Zm-6.7,19.491-7.309-2.57V6.936l7.309,2.57Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#1f3563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.52a1e39aeca1b16b68c5a6b39621224f.svg";
export { ForwardRef as ReactComponent };